import { Request } from '@/http/request'

export function toolDataQuery(params:Record<string,any>){
    return Request.axiosInstance.post('/open/tool/data-query', params)
}
export function bindQuery(params:Record<string,any>){
  return Request.axiosInstance.post('/open/tool/bind-query', params)
}